import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const intimateHealth = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
